module.exports = __webpack_public_path__ + "006ccdca1355ef9233a0733e0f731bbe.svg";